import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';
import PublicHome from '../public/PublicHome';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
  };

  const handleSwitchToRegister = () => {
    navigate('/register');
  };

  return (
    <>
      <PublicHome />
      <LoginModal
        open={true}
        onClose={handleClose}
        onSwitchToRegister={handleSwitchToRegister}
      />
    </>
  );
};

export default LoginPage;
